import React, { useEffect, useState, useRef } from "react";
import { FaLinkedin, FaGithub, FaEnvelope, FaPhone } from "react-icons/fa";
import { github, linkedin, email, contact } from "../config/config";

const Contacts = () => {
  const [visibleIndexes, setVisibleIndexes] = useState([]);
  const refs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const index = parseInt(entry.target.dataset.index);
          if (entry.isIntersecting && !visibleIndexes.includes(index)) {
            setVisibleIndexes((prev) => [...prev, index]);
          }
        });
      },
      { threshold: 0.1 }
    );

    refs.current.forEach((ref) => ref && observer.observe(ref));

    return () => {
      refs.current.forEach((ref) => ref && observer.unobserve(ref));
    };
  }, [visibleIndexes]);

  const contactData = [
    { icon: <FaLinkedin />, label: "LinkedIn", url: linkedin },
    { icon: <FaGithub />, label: "GitHub", url: github },
    { icon: <FaEnvelope />, label: "Email", url: `mailto:${email}` },
    { icon: <FaPhone />, label: "Phone", url: `tel:+91${contact}` },
  ];

  return (
    <section id="contact" className="text-white p-8 flex flex-col items-center">
      <h2 className="text-4xl font-bold neon-glow mb-8 text-center">Contact</h2>

      <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-8 mx-auto">
        {contactData.map((contact, index) => (
          <a
            key={index}
            href={contact.url}
            target="_blank"
            rel="noopener noreferrer"
            data-index={index}
            ref={(el) => (refs.current[index] = el)}
            className={`flex items-center justify-center px-6 py-3 rounded-full bg-white/5 hover:bg-white/10 border border-white/5 hover:border-sky-400/50 text-gray-300 hover:text-white transition-all duration-300 transform ${
              visibleIndexes.includes(index) ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
            }`}
          >
            <span className="mr-3 text-xl">{contact.icon}</span>
            {contact.label}
          </a>
        ))}
      </div>
    </section>
  );
};

export default Contacts;
